import { render } from "./HamburgerMenu.vue?vue&type=template&id=d38cdd08&scoped=true"
import script from "./HamburgerMenu.vue?vue&type=script&lang=js"
export * from "./HamburgerMenu.vue?vue&type=script&lang=js"

import "./HamburgerMenu.vue?vue&type=style&index=0&id=d38cdd08&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d38cdd08"]])

export default __exports__